import { render, staticRenderFns } from "./AllocationList.vue?vue&type=template&id=23904c76"
import script from "./AllocationList.vue?vue&type=script&lang=js"
export * from "./AllocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports